export function Plus() {
  return (
    <path
      fill="currentColor"
      d="M24 0c1.657 0 3 1.343 3 3v18h18c1.598 0 2.904 1.249 2.995 2.824L48 24c0 1.657-1.343 3-3 3H27v18c0 1.598-1.249 2.904-2.824 2.995L24 48c-1.657 0-3-1.343-3-3V27H3C1.402 27 .096 25.751.005 24.176L0 24c0-1.657 1.343-3 3-3h18V3C21 1.402 22.249.096 23.824.005z"
    />
  )
}
